<template>
  <v-container class="max-width-1200">

    <v-row class="pb-8 justify-center">
      <v-col>

        <!-- recommend -->
        <v-row class="pt-8">
          <v-col class="display-1">
            {{ $t('common.ForWho')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('tempering.about.text.03')}}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'TemperingRecommend',
    extends: DataComponentBase,

    data: () => ({
    }),

    methods: {

    },
  }
</script>
